/* corex-textil-redes.js · «Descargar para redes» del personalizador de camisetas (diseño aprobado: pantalla
   «Descarga para redes»). Composición sin coste ni efecto en el pedido:
   - Camisetas reales del color (delante y detrás, fotos con el diseño como en «Así queda puesta»: root.cteRenderPanels),
     recortadas al contenido y juntas, grandes.
   - Debajo, centrado y fuera del área de las camisetas, el logo COREX oficial al 100 % y encima de todo
     (assets/corex-logo-fondo-claro.png o -oscuro.png).
   - Opcional: un logo de fondo (subido o una imagen del diseño) detrás de todo, centrado, girado −24°, cubriendo el
     lienzo y al 30 %.
   - Formatos: PNG transparente (ancho 2600 px) o cuadrado 2160×2160 (fondo claro o negro COREX con degradado radial).
   Reglas de composición puras (layout, coverScale) exportadas para pruebas. Marcado: [data-ctr-*] del snippet. */
(function (global) {
  'use strict';

  var PNG_W = 2600;            /* ancho del PNG transparente (≥ 2400) */
  var SQUARE = 2160;           /* cuadrado: nítido al subirlo a 1080 */
  var PANEL_PX = 1800;         /* ancho de render de cada foto (luego se recorta al contenido) */
  var PREVIEW_PX = 560;        /* vista previa del panel */
  var PREVIEW_PANEL_PX = 520;
  var BG_ROTATION = -24;       /* grados */
  var BG_OPACITY = 0.3;
  var ALPHA_MIN = 8;

  /* Posiciones en el lienzo. shirts: [{ w, h }] (delante, detrás, ya recortadas); logo: { w, h }; size: lado del
     cuadrado o ancho del PNG. Devuelve { W, H, shirts: [{ x, y, w, h }], logo: { x, y, w, h } }. */
  function layout(format, shirts, logo, size) {
    var r = shirts.map(function (s) { return s.w / s.h; }), sum = r[0] + r[1];
    var W, H, gap, h, logoW, gapLogo, top, left;
    if (format === 'cuadrado') {
      W = H = size;
      gap = 0.012 * W;
      h = Math.min(0.64 * H, (0.92 * W - gap) / sum);
      logoW = 0.21 * W;
      gapLogo = 0.03 * W;
    } else {
      W = size;
      var pad = 0.04 * W, block = W - 2 * pad;
      gap = 0.01 * W;
      h = (block - gap) / sum;
      logoW = 0.22 * block;
      gapLogo = 0.03 * W;
    }
    var logoH = logoW * logo.h / logo.w, shirtsW = h * sum + gap, groupH = h + gapLogo + logoH;
    if (format !== 'cuadrado') H = Math.round(groupH + 0.08 * W);
    top = (H - groupH) / 2;
    left = (W - shirtsW) / 2;
    return {
      W: W, H: H,
      shirts: [{ x: left, y: top, w: h * r[0], h: h }, { x: left + h * r[0] + gap, y: top, w: h * r[1], h: h }],
      logo: { x: (W - logoW) / 2, y: top + h + gapLogo, w: logoW, h: logoH }
    };
  }
  /* Escala para que una imagen lw×lh girada `deg` cubra entero un lienzo W×H (puede salirse por los bordes). */
  function coverScale(lw, lh, W, H, deg) {
    var a = Math.abs(deg) * Math.PI / 180, c = Math.cos(a), s = Math.sin(a);
    return Math.max((W * c + H * s) / lw, (W * s + H * c) / lh);
  }
  function slug(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'x';
  }
  function fileName(producto, color) { return 'corex-' + slug(producto) + '-' + slug(color) + '-redes.png'; }

  if (typeof module === 'object' && module.exports) {
    module.exports = { layout: layout, coverScale: coverScale, fileName: fileName, PNG_W: PNG_W, SQUARE: SQUARE };
    return;
  }

  /* ---------- navegador ---------- */
  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (/^https?:/i.test(src)) img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('img')); };
      img.src = src;
    });
  }
  function natural(img) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    return w && h ? { w: w, h: h } : { w: 1000, h: 1000 }; /* SVG sin tamaño */
  }
  /* Recorta un lienzo a la caja de sus píxeles visibles («recortando el aire de las fotos»). */
  function cropAlpha(cv) {
    var c = cv.getContext('2d', { willReadFrequently: true }), d = c.getImageData(0, 0, cv.width, cv.height).data;
    var x0 = cv.width, y0 = cv.height, x1 = -1, y1 = -1;
    for (var y = 0; y < cv.height; y++) {
      for (var x = 0; x < cv.width; x++) {
        if (d[(y * cv.width + x) * 4 + 3] > ALPHA_MIN) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
    }
    if (x1 < 0) return cv;
    var out = document.createElement('canvas');
    out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
    out.getContext('2d').drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }
  function paintBackground(c, W, H, fondo) {
    var cx = W / 2, cy = 0.42 * H, r = Math.max(Math.hypot(cx, cy), Math.hypot(W - cx, H - cy));
    var g = c.createRadialGradient(cx, cy, 0, cx, cy, r);
    if (fondo === 'oscuro') { g.addColorStop(0, '#2a2a2a'); g.addColorStop(0.72, '#141414'); g.addColorStop(1, '#141414'); }
    else { g.addColorStop(0, '#FFFFFF'); g.addColorStop(1, '#ECEAE6'); }
    c.fillStyle = g;
    c.fillRect(0, 0, W, H);
  }
  /* Lienzo final. o: { formato, fondo, panels: [delante, detrás] (recortados), logo (img COREX), fondoLogo (img|null) } */
  function compose(o, size) {
    var L = layout(o.formato, o.panels.map(function (p) { return { w: p.width, h: p.height }; }), natural(o.logo), size);
    var cv = document.createElement('canvas'), c = cv.getContext('2d');
    cv.width = Math.round(L.W); cv.height = Math.round(L.H);
    c.imageSmoothingQuality = 'high';
    if (o.formato === 'cuadrado') paintBackground(c, cv.width, cv.height, o.fondo);
    if (o.fondoLogo) {
      var n = natural(o.fondoLogo), k = coverScale(n.w, n.h, cv.width, cv.height, BG_ROTATION);
      c.save();
      c.globalAlpha = BG_OPACITY;
      c.translate(cv.width / 2, cv.height / 2);
      c.rotate(BG_ROTATION * Math.PI / 180);
      c.drawImage(o.fondoLogo, -n.w * k / 2, -n.h * k / 2, n.w * k, n.h * k);
      c.restore();
    }
    o.panels.forEach(function (p, i) { var s = L.shirts[i]; c.drawImage(p, s.x, s.y, s.w, s.h); });
    c.drawImage(o.logo, L.logo.x, L.logo.y, L.logo.w, L.logo.h);
    return cv;
  }

  function init(root) {
    if (root.dataset.ctrReady || !root.cteRenderPanels) return;
    var q = function (s) { return root.querySelector(s); }, qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var sheet = q('[data-ctr-sheet]');
    if (!sheet) return;
    root.dataset.ctrReady = '1';
    var data;
    try { data = JSON.parse(q('[data-cte-data]').textContent); } catch (e) { return; }
    var cfg = data.redes || {};
    var st = { formato: 'png', fondo: 'claro', color: null, fondoSrc: null, opener: null, busy: false, seq: 0 };
    var panelCache = {}, logos = {}, uploaded = null;

    function design() { return root.cteGetDesign(); }
    function colorOptions() {
      var d = design(), out = [d.color];
      ((d.pedido && d.pedido.matriz) || []).forEach(function (m) { if (out.indexOf(m.color) < 0) out.push(m.color); });
      return out;
    }
    function designImages() {
      var d = design(), out = [];
      Object.keys(d.views || {}).forEach(function (v) {
        (d.views[v].prints || []).forEach(function (p) {
          p.layers.forEach(function (l) { if (l.type === 'image' && out.indexOf(l.src) < 0) out.push(l.src); });
        });
      });
      return out;
    }
    function panels(color, px) {
      var key = color + '|' + px;
      if (!panelCache[key]) {
        panelCache[key] = root.cteRenderPanels(color, px).then(function (list) { return list.map(cropAlpha); })
          .catch(function (e) { delete panelCache[key]; throw e; });
      }
      return panelCache[key];
    }
    function logo(fondo) {
      if (!logos[fondo]) logos[fondo] = loadImage(fondo === 'oscuro' ? cfg.logoOscuro : cfg.logoClaro);
      return logos[fondo];
    }
    function fondoImage() {
      if (!st.fondoSrc) return Promise.resolve(null);
      return loadImage(st.fondoSrc).catch(function () { return null; });
    }
    function build(px, size) {
      return Promise.all([panels(st.color, px), logo(st.fondo), fondoImage()]).then(function (r) {
        return compose({ formato: st.formato, fondo: st.fondo, panels: r[0], logo: r[1], fondoLogo: r[2] }, size);
      });
    }
    function note(text, warn) {
      var n = q('[data-ctr-note]');
      n.textContent = text || '';
      n.className = 'cte-note' + (warn ? ' cte-note--warn' : '');
    }

    /* ---------- panel ---------- */
    function renderOptions() {
      var colors = colorOptions();
      if (colors.indexOf(st.color) < 0) st.color = colors[0];
      var sel = q('[data-ctr-color]');
      sel.innerHTML = colors.map(function (c) { return '<option' + (c === st.color ? ' selected' : '') + '>' + escapeHtml(c) + '</option>'; }).join('');
      q('[data-ctr-color-field]').hidden = colors.length < 2;
      var imgs = designImages();
      q('[data-ctr-imgs]').innerHTML = imgs.map(function (src, i) {
        var on = st.fondoSrc === src;
        return '<button type="button" class="ctr-img' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-ctr-img="' + i + '" aria-label="Usar la imagen ' + (i + 1) + ' del diseño">' +
          '<img src="' + escapeHtml(src) + '" alt=""></button>';
      }).join('');
      qa('[data-ctr-formato]').forEach(function (b) { b.checked = b.value === st.formato; });
      qa('[data-ctr-fondo]').forEach(function (b) { b.checked = b.value === st.fondo; });
      q('[data-ctr-sinlogo]').setAttribute('aria-pressed', String(!st.fondoSrc));
      q('[data-ctr-sinlogo]').classList.toggle('is-on', !st.fondoSrc);
      q('[data-ctr-subido]').hidden = !uploaded;
      if (uploaded) { q('[data-ctr-subido]').classList.toggle('is-on', st.fondoSrc === uploaded); q('[data-ctr-subido]').setAttribute('aria-pressed', String(st.fondoSrc === uploaded)); }
      q('[data-ctr-prev-wrap]').classList.toggle('is-png', st.formato === 'png');
    }
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function preview() {
      var seq = ++st.seq, cv = q('[data-ctr-prev]');
      note('Preparando la vista previa…');
      build(PREVIEW_PANEL_PX, st.formato === 'cuadrado' ? PREVIEW_PX : PREVIEW_PX).then(function (out) {
        if (seq !== st.seq) return;
        cv.width = out.width; cv.height = out.height;
        cv.getContext('2d').drawImage(out, 0, 0);
        note('');
      }).catch(function () { if (seq === st.seq) note('No se ha podido preparar la vista previa. Prueba con otro color o recarga la página.', true); });
    }
    function update(patch) { Object.assign(st, patch); renderOptions(); preview(); }
    function open(opener) {
      st.opener = opener;
      st.color = design().color;
      renderOptions();
      sheet.hidden = false;
      document.documentElement.classList.add('cte-noscroll');
      var f = sheet.querySelector('[data-ctr-formato]:checked') || sheet.querySelector('button');
      if (f) f.focus();
      preview();
    }
    function close() {
      if (sheet.hidden || st.busy) return;
      sheet.hidden = true;
      document.documentElement.classList.remove('cte-noscroll');
      if (st.opener && document.contains(st.opener)) st.opener.focus();
    }
    function download() {
      if (st.busy) return;
      st.busy = true;
      var btn = q('[data-ctr-download]');
      btn.disabled = true;
      note('Generando la imagen en alta resolución…');
      build(PANEL_PX, st.formato === 'cuadrado' ? SQUARE : PNG_W).then(function (cv) {
        return new Promise(function (resolve, reject) { cv.toBlob(function (b) { return b ? resolve(b) : reject(new Error('blob')); }, 'image/png'); });
      }).then(function (blob) {
        var a = document.createElement('a'), url = URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName(data.title, st.color);
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
        note('Imagen descargada: ' + a.download + '.');
      }).catch(function () {
        note('No se ha podido generar la imagen. Inténtalo de nuevo.', true);
      }).then(function () { st.busy = false; btn.disabled = false; });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ctr-open]');
      if (b) open(b);
    });
    sheet.addEventListener('click', function (e) {
      var t = e.target, el;
      if (t === sheet || t.closest('[data-ctr-close]')) return close();
      if (t.closest('[data-ctr-download]')) return download();
      if (t.closest('[data-ctr-sinlogo]')) return update({ fondoSrc: null });
      if (t.closest('[data-ctr-subir]')) return q('[data-ctr-file]').click();
      if (t.closest('[data-ctr-subido]')) return update({ fondoSrc: uploaded });
      if ((el = t.closest('[data-ctr-img]'))) return update({ fondoSrc: designImages()[Number(el.dataset.ctrImg)] || null });
    });
    sheet.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ctr-formato]')) return update({ formato: t.value });
      if (t.matches('[data-ctr-fondo]')) return update({ fondo: t.value });
      if (t.matches('[data-ctr-color]')) return update({ color: t.value });
      if (t.matches('[data-ctr-file]')) {
        var f = t.files && t.files[0];
        t.value = '';
        if (!f) return;
        if (!/^image\/(png|jpeg|svg\+xml)$/.test(f.type)) return note('Formato no admitido: sube un PNG, JPG o SVG.', true);
        if (uploaded) URL.revokeObjectURL(uploaded);
        uploaded = URL.createObjectURL(f);
        update({ fondoSrc: uploaded });
      }
    });
    sheet.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(); } });
    root.cteRedes = { render: function (o) { Object.assign(st, o); return build(PANEL_PX, st.formato === 'cuadrado' ? SQUARE : PNG_W); }, fileName: function () { return fileName(data.title, st.color); } };
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-cte].is-mounted'), init); }
  scan();
  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 0); });
})(this);
